/** @jsx jsx */
import { jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { validIcons } from '@coursera-web/degrees';

import { Grid, Typography2 } from '@coursera/cds-core';
import type { IconProps, Theme } from '@coursera/cds-core';

type Props = {
  iconVariant?: string | null;
  iconColor?: IconProps['color'];
  iconLabel?: string | null; // An optional text label that will appear next to the chosen icon.
  description?: string | null;
  containerStyle?: Interpolation<Theme>;
  iconContainerStyle?: Interpolation<Theme>;
};

export const IconList = ({
  iconVariant,
  iconColor,
  iconLabel,
  description,
  containerStyle,
  iconContainerStyle,
}: Props) => {
  // The possible input values are controlled by a select field in Contentful and is controlled/maintained by engineering
  const Icon = iconVariant && validIcons[iconVariant as keyof typeof validIcons];
  const shouldUseBodyVariant = iconLabel && !description;

  return (
    <div className="rc-IconList" css={containerStyle}>
      <Grid container spacing={16}>
        <Grid item xs={1} css={iconContainerStyle}>
          {Icon && <Icon color={iconColor} />}
        </Grid>
        <Grid item xs>
          {iconLabel && (
            <Typography2
              variant={shouldUseBodyVariant ? 'bodyPrimary' : 'subtitleMedium'}
              component={shouldUseBodyVariant ? 'div' : 'h5'}
            >
              {iconLabel}
            </Typography2>
          )}
          {description && (
            <Typography2 variant="bodyPrimary" component="div" className="description-container">
              {description}
            </Typography2>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default IconList;
